<ng-container *ngIf="isPatient$ | async; then isPatientSchemas; else isDoctorSchemas"></ng-container>

<ng-template #isPatientSchemas>
  <patient-schemas></patient-schemas>
</ng-template>

<ng-template #isDoctorSchemas>
  <doctor-schemas></doctor-schemas>
</ng-template>